module.exports = __webpack_public_path__ + "static/media/NU_Research.5a155cfc.png";